<template>
  <div
    class="switcher"
    :class="[padding, background, { disabled: disabled }, { clickable: !disabled && !disableBody }, { inline: inline }]"
    @click="clickBody">
    <Checkbox
      v-if="type == 'checkbox'"
      v-model:checked="val"
      class="mt-quarter mr-2"
      :locked="locked"
      :disabled="disabled"
      :size="16"
      @update:checked="toggle" />
    <Toggler v-else v-model="val" :locked="locked" :disabled="disabled" @input="toggle" :withoutStyleDisabled="withoutStyleDisabled" />
    <div v-if="custom" class="switcher-desc" @click.stop="clickBody">
      <slot :hander="toggleManual"></slot>
    </div>
    <div v-else class="switcher-desc">
      <p class="typo-paragraph14 typo-regular text-light-high mb-half noselect">
        <slot name="title"></slot>
      </p>
      <p class="typo-paragraph12 typo-regular text-light-low">
        <slot name="subtitle"></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Switcher',
  props: {
    value: Boolean,
    locked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'toggle',
    },
    padding: {
      type: String,
      default: 'p-2',
    },
    background: {
      type: String,
      default: 'bg-light1',
    },
    disableBody: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: true,
    },
    withoutStyleDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:value'],
  data() {
    return {
      val: false,
    };
  },
  computed: {},
  watch: {
    value(newV) {
      if (this.val != newV) this.val = newV;
    },
  },
  created() {
    this.val = this.value;
  },
  methods: {
    toggle() {
      this.$emit('update:value', this.val);
    },
    toggleManual() {
      if (this.disabled) {
        return;
      }
      this.val = !this.val;
      this.toggle();
    },
    clickBody(e) {
      if (this.disableBody) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.toggleManual();
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-quarter {
  margin-top: 2px;
}
.switcher {
  display: flex;
  flex-direction: row;
  &.inline {
    display: inline-flex;
  }

  &-desc {
    flex: 1;
  }

  &.disabled {
    cursor: not-allowed;
  }
}
.clickable {
  cursor: pointer;
}
</style>
